// extracted by mini-css-extract-plugin
module.exports = {"companionAd":"CamCompanionAd_companionAd__YBgOS","companionAdBelowCam":"CamCompanionAd_companionAdBelowCam__6ZMds"};